import { MainHeader } from 'application/presentation/common/Header'
import ToastNotify from 'application/presentation/context/ToastNotify/ToastNotify'
import React, { useState, useCallback, useEffect, useMemo } from 'react'
import FormContainer from 'application/presentation/common/FormContainer/FormContainer'
import { PinCodeInput } from 'application/presentation/common/uiComponents/InputComponents'
import { Button } from 'application/presentation/common/uiComponents'
import { useLocation, useNavigate } from 'react-router'

import { useAuthorization } from './useAuthorization'
import s from './AuthPage.module.scss'

const RegistrationPasswordPage = () => {
  const navigate = useNavigate()
  const { search } = useLocation()
  const [newPassword, setNewPassword] = useState<string>('')
  const [passwordConfim, setPasswordConfirm] = useState<string>('')
  const [stage, setStage] = useState<number>(1)

  const phone = useMemo(() => {
    const params = new URLSearchParams(search)
    const p = params.get('phone')
    return p || ''
  }, [search])

  const { regIsLoading, register } = useAuthorization({})

  const registerClickHandler = useCallback(() => {
    if (newPassword !== passwordConfim) {
      return ToastNotify('Пин-коды не совпадают')
    }
    return register(phone, newPassword, () => {
      ToastNotify('Регистрация прошла успешно')
      navigate('/select_car')
    })
  }, [phone, newPassword, passwordConfim, navigate, register])

  useEffect(() => {
    if (stage === 1 && newPassword.length === 4) {
      setStage(2)
    }
    if (stage === 2 && passwordConfim.length === 4) {
      registerClickHandler()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [stage, newPassword, passwordConfim])
  return (
    <>
      <MainHeader />
      <div className={s.container}>
        {stage === 1 && (
          <FormContainer title="Придумайте Ваш пин-код" subtitle="Введите его сюда">
            <PinCodeInput onChange={setNewPassword} controlled />
            {newPassword.length === 4 && (
              <Button
                color="fiol"
                text="Далее"
                type="submit"
                stopEvents
                onClick={() => setStage(2)}
                containerClassName={s.btn}
              />
            )}
          </FormContainer>
        )}
        {stage === 2 && (
          <FormContainer title="Повторите Ваш пин-код" subtitle="Введите его сюда">
            <PinCodeInput onChange={setPasswordConfirm} controlled />
            {passwordConfim.length === 4 && (
              <Button
                color="fiol"
                text="Далее"
                onClick={registerClickHandler}
                type="submit"
                stopEvents
                containerClassName={s.btn}
                isLoading={regIsLoading}
              />
            )}
          </FormContainer>
        )}
      </div>
    </>
  )
}

export default React.memo(RegistrationPasswordPage)
